jQuery(document).ready(function($) {
    $('.filters__select').on('change', function() {
        $(this).closest('form').submit();
    });
});